
import { SelectPlainObject } from './select.plainObject';
import { ColumnPlainObject } from './column.plainObject';
import { ExpressionColumnBasePlainObject } from './expressionColumn.plainObject';
import { ColumnMappingBaseTransformPlainObject } from './columnMappingBase.plainObject';

export class CallPlainObject extends ColumnMappingBaseTransformPlainObject {
    public configs: Map<string, string>;
    public selectObject: SelectPlainObject;
    public outputDefinition: ColumnPlainObject[];
    public columns: ExpressionColumnBasePlainObject[] = [];
    public columnConfigs: Map<ExpressionColumnBasePlainObject, ExpressionColumnBasePlainObject>;
}
